/**
 * Ограничения по карте — единый список для двух мест: перед выпуском показываем целиком
 * (пропустить нельзя), после выпуска — свёрнутой строкой на экране карты, раскрывается тапом.
 */
import { useState } from "react";

export const RESTRICTIONS = [
  "Финансовые инвестиции и управление активами",
  "Азартные игры",
  "Транзакции, связанные с продуктами для взрослых",
  "Покупка подарочных карт",
  "Оплата российских сервисов и покупок на территории РФ",
];

function List() {
  return (
    <ul className="space-y-1.5">
      {RESTRICTIONS.map((r) => (
        <li key={r} className="flex gap-2 text-[13px] leading-snug text-white/65">
          <span className="mt-px shrink-0 text-[13px] font-semibold text-rose-400/90">×</span>
          <span>{r}</span>
        </li>
      ))}
    </ul>
  );
}

/** Развёрнутый блок — экран подтверждения выпуска. */
export function RestrictionsBlock({ className = "" }: { className?: string }) {
  return (
    <div className={`rounded-2xl border border-white/[0.06] bg-surface-card px-4 py-3.5 ${className}`}>
      <div className="mb-2 text-[13px] font-medium text-white/80">Запрещённые операции</div>
      <List />
    </div>
  );
}

/** Свёрнутая строка — экран карты. По умолчанию закрыта, чтобы не мозолить глаза. */
export function RestrictionsCollapsible({ className = "" }: { className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`overflow-hidden rounded-2xl border border-white/[0.06] bg-surface-card ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 px-4 py-3.5 text-left active:bg-white/[0.03]"
      >
        <span className="min-w-0 flex-1 text-[14px] text-white/70">Что нельзя оплачивать картой</span>
        <svg
          viewBox="0 0 20 20"
          className={`h-4 w-4 shrink-0 text-white/40 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
        >
          <path d="M6 8l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && (
        <div className="px-4 pb-3.5">
          <List />
        </div>
      )}
    </div>
  );
}
